import React from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const ChatMessage = props => (
  <div className="d-f">
    {props.renderAvatar('ReplyContainer--activeReply')}
    <div className="d-f fd-c">
      <Text
        className="ReplyContainer-chatMessage ws-pl"
        variant={TEXT_VARIANTS.SUBHEADER}
      >
        {props.questionChatData.message}
      </Text>
      <Text variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}>
        {props.i18n.sent_time}
      </Text>
    </div>
  </div>
);

export default ChatMessage;
